import { render, staticRenderFns } from "./test1-3.vue?vue&type=template&id=4d13763b&scoped=true"
import script from "./test1-3.vue?vue&type=script&lang=js"
export * from "./test1-3.vue?vue&type=script&lang=js"
import style0 from "./test1-3.vue?vue&type=style&index=0&id=4d13763b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13763b",
  null
  
)

export default component.exports